/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderChallenge } from './LadderChallenge';
import {
    LadderChallengeFromJSON,
    LadderChallengeFromJSONTyped,
    LadderChallengeToJSON,
    LadderChallengeToJSONTyped,
} from './LadderChallenge';

/**
 * 
 * @export
 * @interface CompleteLadderChallengeResponse
 */
export interface CompleteLadderChallengeResponse {
    /**
     * 
     * @type {LadderChallenge}
     * @memberof CompleteLadderChallengeResponse
     */
    challenge: LadderChallenge;
}

/**
 * Check if a given object implements the CompleteLadderChallengeResponse interface.
 */
export function instanceOfCompleteLadderChallengeResponse(value: object): value is CompleteLadderChallengeResponse {
    if (!('challenge' in value) || value['challenge'] === undefined) return false;
    return true;
}

export function CompleteLadderChallengeResponseFromJSON(json: any): CompleteLadderChallengeResponse {
    return CompleteLadderChallengeResponseFromJSONTyped(json, false);
}

export function CompleteLadderChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteLadderChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': LadderChallengeFromJSON(json['challenge']),
    };
}

export function CompleteLadderChallengeResponseToJSON(json: any): CompleteLadderChallengeResponse {
    return CompleteLadderChallengeResponseToJSONTyped(json, false);
}

export function CompleteLadderChallengeResponseToJSONTyped(value?: CompleteLadderChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge': LadderChallengeToJSON(value['challenge']),
    };
}

